import { render, staticRenderFns } from "./assuraf_pro_online.vue?vue&type=template&id=c1bdb820&scoped=true"
import script from "./assuraf_pro_online.vue?vue&type=script&lang=js"
export * from "./assuraf_pro_online.vue?vue&type=script&lang=js"
import style0 from "./assuraf_pro_online.vue?vue&type=style&index=0&id=c1bdb820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bdb820",
  null
  
)

export default component.exports